import { observer } from 'mobx-react';

const InputWrapper = observer(({ className = '', children }) => {
  return <div className={className}>{children}</div>;
});

export default InputWrapper;
